(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('hs-cart')) customElements.define('hs-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true; this.dialog = this.querySelector('dialog'); this.queue = Promise.resolve(); this.pending = 0;
      this.quantityTimers = new Map(); this.requestedQuantities = new Map();
      window.HSCart = this; document.body.dataset.cartReady = '';
      document.addEventListener('click', event => {
        const opener = event.target.closest('[data-cart-open]');
        if (opener) { event.preventDefault(); this.open(opener); }
        const remove = event.target.closest('.cart-form [data-cart-remove][data-key]');
        if (remove) { event.preventDefault(); this.change(remove.dataset.key,0); }
      });
      document.addEventListener('change', event => {
        if (event.target.matches('[data-upsell-variant]')) {
          const option = event.target.selectedOptions[0];
          const price = event.target.closest('[data-upsell-card]').querySelector('[data-upsell-price]');
          if (option?.dataset.price && price) price.textContent = option.dataset.price;
        }
        if (event.target.matches('[data-cart-note]')) this.saveNote(event.target.value);
        if (event.target.matches('.cart-form [data-cart-quantity][data-key]')) {
          if (!event.target.dataset.key?.trim() || !event.target.reportValidity()) return;
          clearTimeout(this.quantityTimers.get(event.target.dataset.key));
          this.change(event.target.dataset.key,Number(event.target.value));
        }
      });
      document.addEventListener('input', event => {
        const input = event.target;
        if (!input.matches('.cart-form [data-cart-quantity][data-key]')) return;
        const key = input.dataset.key;
        clearTimeout(this.quantityTimers.get(key));
        if (!key?.trim() || input.value === '' || !input.validity.valid) return;
        const quantity = Number(input.value);
        this.quantityTimers.set(key,setTimeout(() => this.change(key,quantity),350));
      },true);
      document.addEventListener('submit', async event => {
        if (event.target.matches('[data-upsell-form]')) {
          event.preventDefault();
          await this.addUpsell(event.target);
          return;
        }
        if (!event.target.matches('.cart-form') || !this.pending) return;
        event.preventDefault();
        if (this.submitting) return;
        this.submitting = true;
        const formId = event.target.id; const buttonName = event.submitter?.name;
        while (this.pending) await this.queue.catch(() => {});
        this.submitting = false;
        const form = document.getElementById(formId);
        const button = form && [...form.elements].find(item => item.tagName === 'BUTTON' && item.type === 'submit' && item.name === buttonName);
        if (button) form.requestSubmit(button);
      });
      this.dialog.addEventListener('close',() => this.opener?.isConnected && this.opener.focus({preventScroll:true}));
    }
    open(opener) { this.opener = opener || this.opener; document.querySelectorAll('dialog[open]').forEach(d => { if (d !== this.dialog) d.close(); }); if (!this.dialog.open) this.dialog.showModal(); }
    run(task) {
      this.pending++; this.setBusy(true);
      const result = this.queue.catch(() => {}).then(task);
      this.queue = result.finally(() => { this.pending--; if (!this.pending) this.setBusy(false); });
      this.queue.catch(() => {});
      return result;
    }
    setBusy(value) { document.querySelectorAll('.cart-form [data-cart-quantity]').forEach(el => { el.disabled = value; }); document.querySelectorAll('.cart-form').forEach(el => el.setAttribute('aria-busy',String(value))); }
    sections() { return [this.dataset.sectionId,...document.querySelectorAll('[data-main-cart]')].map(item => typeof item === 'string' ? item : item.dataset.sectionId); }
    async request(url,body,form = false) {
      const response = await fetch(url + '.js',{method:'POST',headers:form ? {'Accept':'application/json'} : {'Content-Type':'application/json','Accept':'application/json'},body:form ? body : JSON.stringify(body)});
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
      return data;
    }
    clearErrors() { document.querySelectorAll('[data-cart-error],[data-upsell-error]').forEach(el => { el.textContent = ''; }); }
    async add(form,opener) {
      return this.run(async () => {
        this.clearErrors();
        const body = new FormData(form); body.set('sections',this.sections().join(',')); body.set('sections_url',location.pathname);
        const data = await this.request(this.dataset.addUrl,body,true);
        if (!await this.renderFresh(data.sections)) { location.assign(this.dataset.cartUrl); return; }
        this.open(opener);
      });
    }
    async addUpsell(form) {
      if (form.hasAttribute('data-busy') || !form.reportValidity()) return;
      const body = new FormData(form);
      const button = form.querySelector('[data-upsell-submit]');
      const originalLabel = button.innerHTML;
      const errorElement = form.querySelector('[data-upsell-error]');
      const scope = form.closest('[data-main-cart]') || this.dialog;
      body.set('sections',this.sections().join(',')); body.set('sections_url',location.pathname);
      form.dataset.busy = ''; form.setAttribute('aria-busy','true');
      errorElement.textContent = ''; button.disabled = true; button.textContent = button.dataset.loadingLabel;
      return this.run(async () => {
        try {
          const data = await this.request(this.dataset.addUrl,body,true);
          if (!await this.renderFresh(data.sections)) { location.assign(this.dataset.cartUrl); return; }
          const status = document.getElementById('HS-Status'); if (status) status.textContent = this.dataset.updated;
          scope.querySelector('[data-checkout]')?.focus({preventScroll:true});
        } catch(error) {
          if (errorElement.isConnected) errorElement.textContent = error.message || this.dataset.error;
          else document.querySelectorAll('[data-cart-error]').forEach(el => { el.textContent = error.message || this.dataset.error; });
        } finally {
          if (form.isConnected) { delete form.dataset.busy; form.removeAttribute('aria-busy'); button.disabled = false; button.innerHTML = originalLabel; }
        }
      });
    }
    change(key,quantity) {
      if (typeof key !== 'string' || !key.trim() || !Number.isInteger(quantity) || quantity < 0) return Promise.resolve();
      if (this.requestedQuantities.get(key) === quantity) return Promise.resolve();
      this.requestedQuantities.set(key,quantity);
      return this.run(async () => {
        document.querySelectorAll('[data-cart-error]').forEach(el => { el.textContent = ''; });
        const active = document.activeElement; const focusKey = active?.dataset.key;
        try {
          const data = await this.request(this.dataset.changeUrl,{id:key,quantity,sections:this.sections(),sections_url:location.pathname});
          if (!await this.renderFresh(data.sections)) { location.assign(this.dataset.cartUrl); return; }
          if (focusKey) { const scope = this.dialog.open ? this.dialog : document.querySelector('[data-main-cart]'); const target = [...scope.querySelectorAll('[data-cart-quantity]')].find(el => el.dataset.key === focusKey); (target || scope.querySelector('[data-checkout],.button'))?.focus({preventScroll:true}); }
          const status = document.getElementById('HS-Status'); if (status) status.textContent = this.dataset.updated;
        } catch(error) { document.querySelectorAll('[data-cart-error]').forEach(el => { el.textContent = error.message || this.dataset.error; }); }
        finally { if (this.requestedQuantities.get(key) === quantity) this.requestedQuantities.delete(key); }
      });
    }
    saveNote(note) {
      return this.run(async () => {
        try {
          await this.request(this.dataset.updateUrl,{note});
          document.querySelectorAll('[data-cart-note]').forEach(field => { if (field !== document.activeElement) field.value = note; });
          document.querySelectorAll('[data-cart-error]').forEach(el => { el.textContent = ''; });
        } catch(error) { document.querySelectorAll('[data-cart-error]').forEach(el => { el.textContent = error.message || this.dataset.error; }); }
      });
    }
    async renderFresh(sections) {
      if (this.render(sections)) return true;
      try {
        const url = new URL(this.dataset.cartUrl,location.origin); url.searchParams.set('sections',this.sections().join(','));
        const response = await fetch(url,{headers:{'Accept':'application/json'}});
        return response.ok && this.render(await response.json());
      } catch { return false; }
    }
    render(sections) {
      const html = sections?.[this.dataset.sectionId];
      if (!html) return false;
      const doc = new DOMParser().parseFromString(html,'text/html'); const content = doc.querySelector('[data-cart-content]');
      if (!content) return false;
      const count = content.dataset.itemCount;
      const note = this.querySelector('[data-cart-note]')?.value;
      const scrollTop = this.querySelector('.cart-scroll')?.scrollTop || 0;
      this.querySelector('[data-cart-content]').replaceWith(content);
      const scroll = this.querySelector('.cart-scroll'); if (scroll) scroll.scrollTop = scrollTop;
      if (note !== undefined && this.querySelector('[data-cart-note]')) this.querySelector('[data-cart-note]').value = note;
      document.querySelectorAll('[data-main-cart]').forEach(main => { const pageHTML = sections[main.dataset.sectionId]; if (pageHTML) { const parsed = new DOMParser().parseFromString(pageHTML,'text/html'); const fresh = parsed.querySelector('[data-cart-content]'); if (fresh) { const pageNote = main.querySelector('[data-cart-note]')?.value; main.querySelector('[data-cart-content]').replaceWith(fresh); if (pageNote !== undefined && main.querySelector('[data-cart-note]')) main.querySelector('[data-cart-note]').value = pageNote; } } });
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
      this.clearErrors();
      this.setBusy(this.pending > 0);
      return true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.site-header');
  if (header) new ResizeObserver(entries => document.documentElement.style.setProperty('--header-height',`${entries[0].target.getBoundingClientRect().height}px`)).observe(header);
  document.addEventListener('click', event => {
    document.querySelectorAll('.header-nav details[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
    if (event.target.closest('[data-dialog-open],[data-cart-open]')) document.querySelector('.mobile-nav')?.removeAttribute('open');
    if (event.target.closest('.mobile-nav__panel a')) document.querySelector('.mobile-nav')?.removeAttribute('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer"]) return;
  try {
    
  document.querySelectorAll('[data-country-select]').forEach(select => { const option = [...select.options].find(o => o.value === select.dataset.default || o.text === select.dataset.default); if (option) select.value = option.value; });
  if (location.hash === '#recover') document.getElementById('recover')?.setAttribute('open','');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('hs-product')) customElements.define('hs-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = this.querySelector('[data-product-form]');
      this.select = this.querySelector('[data-variant-select]');
      this.button = this.querySelector('[data-add-button]');
      this.error = this.querySelector('[data-product-error]');
      this.variant = this.variants.find(v => String(v.id) === this.select.value);
      this.dataset.ready = '';
      this.track = this.querySelector('[data-gallery]');
      this.mediaItems = [...this.querySelectorAll('[data-media-id]')];
      this.currentMedia = 0;
      this.querySelector('[data-gallery-controls]')?.removeAttribute('hidden');
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.mediaFrame); this.mediaFrame = requestAnimationFrame(() => this.syncGallery()); }, {passive:true});
      this.syncGallery();
      const facts = this.querySelector('[data-product-facts]');
      const factTexts = [...this.querySelectorAll('[data-product-description] li,[data-product-description] p')].map(el => el.textContent.trim()).filter(text => /^(fabric|material|fit|fabric weight|weight|composition)\s*:/i.test(text) && text.length < 130);
      if (!facts.children.length) [...new Set(factTexts)].slice(0,3).forEach(text => { const item = document.createElement('li'); item.setAttribute('role','listitem'); item.textContent = text; facts.append(item); });
      facts.hidden = !facts.children.length;
      this.bundleObserver = new MutationObserver(() => this.syncBundle());
      this.bundleObserver.observe(this.form,{childList:true,subtree:true});
      this.syncBundle();
      this.addEventListener('change', event => { if (event.target.matches('.option-pill input')) this.updateVariant(); });
      this.addEventListener('click', event => {
        const zoom = event.target.closest('[data-zoom-src]');
        if (zoom) this.openZoom(zoom);
        if (event.target.closest('[data-zoom-toggle]')) { const expanded = this.querySelector('[data-zoom-content]').classList.toggle('is-zoomed'); this.querySelector('[data-zoom-toggle]').setAttribute('aria-pressed',String(expanded)); }
        const step = event.target.closest('[data-gallery-step]');
        if (step) { const index = Math.max(0,Math.min(this.mediaItems.length-1,this.currentMedia + Number(step.dataset.galleryStep))); this.showMedia(this.mediaItems[index].dataset.mediaId); }
        const quantity = event.target.closest('[data-quantity-step]');
        if (quantity) { const input = this.form.elements.quantity; if (Number(quantity.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown(); input.dispatchEvent(new Event('change',{bubbles:true})); }
        const thumb = event.target.closest('[data-media-link]');
        if (thumb) { event.preventDefault(); this.showMedia(thumb.dataset.mediaLink); }
        if (event.target.closest('[data-sticky-add]')) { if (this.form.reportValidity()) this.form.requestSubmit(this.button); }
        if (event.target.closest('[data-fit-open]')) { event.preventDefault(); this.openFit(); }
        if (event.target.closest('[data-options-open]')) { event.preventDefault(); const options = this.querySelector('.variant-options'); options?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'}); options?.querySelector('input:checked')?.focus({preventScroll:true}); }
      });
      this.form.addEventListener('submit', event => this.addToCart(event));
      this.updateAvailability();
      if (this.variant?.mediaId) this.showMedia(this.variant.mediaId, false);
      const sticky = this.querySelector('[data-sticky-purchase]');
      if (sticky) {
        this.syncSticky = () => { sticky.hidden = this.button.getBoundingClientRect().bottom > 0; };
        this.scheduleSticky = () => { cancelAnimationFrame(this.stickyFrame); this.stickyFrame = requestAnimationFrame(this.syncSticky); };
        this.observer = new IntersectionObserver(this.syncSticky); this.observer.observe(this.button);
        window.addEventListener('scroll',this.scheduleSticky,{passive:true});
        window.addEventListener('resize',this.scheduleSticky);
        this.syncSticky();
      }
    }
    disconnectedCallback() { this.bundleObserver?.disconnect(); this.observer?.disconnect(); cancelAnimationFrame(this.mediaFrame); cancelAnimationFrame(this.stickyFrame); if (this.scheduleSticky) { window.removeEventListener('scroll',this.scheduleSticky); window.removeEventListener('resize',this.scheduleSticky); } }
    updateVariant() {
      const options = [...this.querySelectorAll('.option-group')].map(group => group.querySelector('input:checked')?.value);
      this.variant = this.variants.find(v => v.options.every((value,index) => value === options[index]));
      this.select.value = this.variant ? String(this.variant.id) : '';
      this.select.disabled = !this.variant;
      this.querySelectorAll('.option-group').forEach(group => { group.querySelector('[data-option-label]').textContent = group.querySelector('input:checked')?.value || ''; });
      this.querySelector('[data-product-price]').innerHTML = this.variant?.priceHtml || this.dataset.unavailableLabel;
      this.button.disabled = !this.variant?.available;
      this.button.textContent = this.variant ? (this.variant.available ? this.dataset.addLabel : this.dataset.soldLabel) : this.dataset.unavailableLabel;
      this.error.textContent = '';
      const sticky = this.querySelector('[data-sticky-purchase]');
      if (sticky) { sticky.querySelector('[data-sticky-selection]').textContent = this.variant?.title || this.dataset.unavailableLabel; sticky.querySelector('[data-sticky-price]').textContent = this.variant?.priceText || ''; const button = sticky.querySelector('button'); button.disabled = !this.variant?.available; button.textContent = this.button.textContent; }
      if (this.variant) { const url = new URL(location.href); url.searchParams.set('variant',this.variant.id); history.replaceState({},'',url); if (this.variant.mediaId) this.showMedia(this.variant.mediaId); }
      this.updateAvailability();
      document.dispatchEvent(new CustomEvent('hs:variant-change',{detail:{variant:this.variant,form:this.form}}));
    }
    syncBundle() {
      const note = this.querySelector('[data-bundle-intro]');
      if (note) note.hidden = !this.form.querySelector('.bndlr-quantity-break');
    }
    updateAvailability() {
      const help = this.querySelector('[data-availability-help]');
      if (help) help.hidden = Boolean(this.variant?.available);
      const selected = [...this.querySelectorAll('.option-group')].map(g => g.querySelector('input:checked')?.value);
      this.querySelectorAll('.option-group').forEach((group,index) => { group.querySelectorAll('.option-pill').forEach(pill => { const value = pill.querySelector('input').value; const available = this.variants.some(v => v.available && v.options[index] === value && v.options.every((option,i) => i >= index || option === selected[i])); pill.toggleAttribute('data-unavailable',!available); pill.querySelector('input').setAttribute('aria-description',available ? '' : this.dataset.soldLabel); }); });
    }
    showMedia(id, smooth = true) {
      const track = this.querySelector('[data-gallery]'); const target = this.querySelector(`[data-media-id="${id}"]`);
      if (!target) return;
      const image = target.querySelector('img'); if (image) image.loading = 'eager';
      track.scrollTo({left:target.offsetLeft - track.firstElementChild.offsetLeft,behavior:smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
      this.querySelectorAll('[data-media-link]').forEach(link => link.setAttribute('aria-current',String(link.dataset.mediaLink === String(id))));
    }
    syncGallery() {
      if (!this.mediaItems.length) return;
      const first = this.mediaItems[0].offsetLeft;
      this.currentMedia = this.mediaItems.reduce((best,item,index) => Math.abs(item.offsetLeft-first-this.track.scrollLeft) < Math.abs(this.mediaItems[best].offsetLeft-first-this.track.scrollLeft) ? index : best,0);
      const id = this.mediaItems[this.currentMedia].dataset.mediaId;
      this.querySelectorAll('[data-media-link]').forEach(link => link.setAttribute('aria-current',String(link.dataset.mediaLink === id)));
      const status = this.querySelector('[data-gallery-status]');
      if (status) status.textContent = status.dataset.format.replace('[current]',String(this.currentMedia+1));
      this.querySelectorAll('[data-gallery-step]').forEach(button => { button.disabled = Number(button.dataset.galleryStep)<0 ? this.currentMedia===0 : this.currentMedia===this.mediaItems.length-1; });
    }
    openZoom(button) {
      const container = this.querySelector('[data-zoom-content]');
      const image = new Image(); image.src = button.dataset.zoomSrc; image.alt = button.dataset.zoomAlt; image.width = Number(button.dataset.imageWidth); image.height = Number(button.dataset.imageHeight);
      container.replaceChildren(image); container.classList.remove('is-zoomed'); container.scrollTo(0,0);
      this.querySelector('[data-zoom-toggle]').setAttribute('aria-pressed','false');
      this.querySelector('.media-dialog').showModal();
    }
    openFit() {
      const content = this.querySelector('[data-fit-content]');
      if (!content.dataset.loaded) {
        const description = this.querySelector('[data-product-description]');
        const fit = [...description.querySelectorAll('li,p')].find(el => /^fit\s*:/i.test(el.textContent.trim()));
        if (fit) { const p = document.createElement('p'); p.textContent = fit.textContent; content.append(p); }
        let chartCount = 0;
        description.querySelectorAll('table').forEach(table => { if (/\b(chest|waist|length|shoulder|inseam|hip|inch|cm)\b/i.test(table.textContent)) { const clone = table.cloneNode(true); clone.querySelectorAll('script,style,iframe').forEach(el => el.remove()); [clone,...clone.querySelectorAll('*')].forEach(el => { el.removeAttribute('id'); el.removeAttribute('style'); }); content.append(clone); chartCount++; } });
        this.querySelector('[data-fit-missing]').hidden = chartCount > 0;
        content.dataset.loaded = '';
      }
      this.querySelector('.fit-dialog').showModal();
    }
    async addToCart(event) {
      if (!window.HSCart || event.submitter?.name !== 'add') return;
      event.preventDefault();
      if (this.busy || !this.variant?.available) return;
      this.busy = true; this.error.textContent = ''; this.button.disabled = true; this.button.textContent = this.dataset.loadingLabel;
      const stickyButton = this.querySelector('[data-sticky-add]'); if (stickyButton) stickyButton.disabled = true;
      try { await window.HSCart.add(this.form, event.submitter); }
      catch (error) { this.error.textContent = error.message || this.dataset.errorLabel; }
      finally { this.busy = false; this.button.disabled = !this.variant?.available; this.button.textContent = this.variant?.available ? this.dataset.addLabel : this.dataset.soldLabel; if (stickyButton) stickyButton.disabled = !this.variant?.available; }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
